import { isEmbeddedSidebar } from '@/lib/embedded-sidebar';
import { cn } from '@/lib/utils';

import { DisclosureFooterLink } from '@/components/RightSidebar/DM/DisclosureFooterLink';

export default function ChatDisclaimer() {
    return (
        <div
            className={cn(
                'flex flex-col',
                isEmbeddedSidebar ? 'mt-4 mb-1' : 'mt-6 mb-3'
            )}
        >
            <p
                className={cn(
                    'text-muted-foreground text-center',
                    isEmbeddedSidebar ? 'text-xs' : 'px-4 text-sm'
                )}
            >
                AI can make mistakes. Dataminds does not use your workspace
                data to train AI models.{' '}
                {!isEmbeddedSidebar && <DisclosureFooterLink />}
            </p>
            <p
                className={cn(
                    'text-muted-foreground text-center',
                    isEmbeddedSidebar ? 'text-xs' : 'px-4 text-sm pb-1'
                )}
            >
                Use this AI agent tool in accordance with your organization’s
                cybersecurity policies and General Instructions.
            </p>
        </div>
    );
}
